import React from 'react';
import PropTypes from 'prop-types';

import SummaryCounter from 'components/Section/History/SummaryCounter';
import { i18n } from 'config/locales';
import { isPVQForm } from 'helpers/form';

const EducationSummaryProgress = function (props) {
  const {
    items, errors, formType, isHistoricalDegree
  } = props;

  const validSchoolItems = items.filter((i) => {
    if (!i.Item) { return false; }
    if (!errors || !errors.length) { return true; }
    if (errors.filter((e) => e.indexOf(i.uuid) > -1).length > 0) { return false; }
    return true;
  });

  let validDiplomaItems = 0;
  validSchoolItems.forEach((i) => {
    if (i.Item.Diplomas && i.Item.Diplomas.items) {
      i.Item.Diplomas.items.forEach((d) => {
        if (d.Item && d.Item.Has && d.Item.Has.value === 'Yes') { validDiplomaItems += 1; }
      });
    }
  });

  const isPvq = isPVQForm(formType);
  return isPvq ? (
    <SummaryCounter
      className="education"
      schoolCount={validSchoolItems.length}
      diplomaCount={validDiplomaItems}
      title={props.isHistoricalDegree ? i18n.t('history.pvq.education.summary.degreeTitle') : i18n.t('history.pvq.education.summary.title')}
    />
  ) : (
    <SummaryCounter
      className="education"
      schoolCount={validSchoolItems.length}
      diplomaCount={validDiplomaItems}
      title={i18n.t('history.education.summary.title')}
    />
  );
};

EducationSummaryProgress.propTypes = {
  items: PropTypes.array,
  errors: PropTypes.array,
  isHistoricalDegree: PropTypes.bool,
};

EducationSummaryProgress.defaultProps = {
  items: [],
  errors: [],
  isHistoricalDegree: false,
  formType: '',
};

export default EducationSummaryProgress;
